import React from 'react';
import './Features.css';

const Features = () => {
  return (
    <div className="about-page">
    <h2 className='abs'>About Us</h2>
    <div className='about-mats'>
      <section className="about-grid">
        <h2 className='heab'>About Us</h2>
        <p>We are a passionate team of developers and designers dedicated to enhancing your note-taking
         and document management experience. Our app is designed with one clear goal in mind:
         to make your life easier, whether you're a student, professional,
          or simply someone who values organized information..</p>
      </section>
      <section className="about-grid">
        <h2 className='heab'>Our Mission</h2>
        <p>At Notes & Papers, we believe that efficient note-taking and document management are essential 
        for success in today's fast-paced world. Our mission is to provide you with a seamless, intuitive,
         and feature-rich platform that empowers you to capture ideas, create documents, and manage your 
         digital life effortlessly.</p>
      </section>
      <section className="about-grid">
        <h2 className='heab'>Our Team</h2>
        <p>We invite you to join our growing community of users who have chosen Notes &
         Papers as their go-to app for notes and document management.
         Your feedback and suggestions are invaluable to us as we strive to make our app even better.</p>
      </section>
      </div>
    </div>
  );
};

export default Features;
